module.exports = __webpack_public_path__ + "img/anew.2ac07c9a.png";